import {Children, Fragment, isValidElement} from 'react'
import type {AriaAttributes, ReactNode} from 'react'

export const sidebarChildKind = Symbol('sidebarChildKind')

export type SidebarCurrentProps = Pick<AriaAttributes, 'aria-current'> & {current?: boolean; inactiveText?: string}

export function getCurrentState({current, inactiveText, 'aria-current': ariaCurrent}: SidebarCurrentProps) {
  const hasAriaCurrent = ariaCurrent != null && ariaCurrent !== false && ariaCurrent !== 'false'
  const isCurrent = inactiveText !== undefined ? false : (current ?? hasAriaCurrent)
  return {
    current: isCurrent,
    ariaCurrent: isCurrent ? (hasAriaCurrent ? ariaCurrent : 'page') : undefined,
  } as const
}

/** Inspect known containers, fragments, and component-boundary current props, never rendered trees. */
export function containsCurrent(children: ReactNode): boolean {
  return Children.toArray(children).some(child => {
    if (!isValidElement<SidebarCurrentProps & {children?: ReactNode}>(child)) return false
    if (child.type === Fragment) return containsCurrent(child.props.children)
    if ((typeof child.type !== 'function' && typeof child.type !== 'object') || child.type === null) return false
    if (sidebarChildKind in child.type && child.type[sidebarChildKind] === 'container') {
      return containsCurrent(child.props.children)
    }
    return getCurrentState(child.props).current
  })
}
